import angular from "angular";
import controller from "./order.controller";
import template from "./order.html";
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.student.order", {
    url: "/orders/:orderID",
    controller: controller,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.student,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("student.order", [])
  .config(config)
  .controller("StudentOrderController", controller);

